<template>
    <svg width="9px" height="6px" viewBox="0 0 9 6" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
            <g id="v9" transform="translate(-157.000000, -201.000000)" stroke="#000000">
                <g id="Group-4" transform="translate(157.500000, 200.500000)">
                    <path d="M7.625,1.25 L2.375,1.25" id="Line-3"></path>
                    <path d="M7.625,5.25 L2.375,5.25" id="Line-3-Copy-2"></path>
                    <path d="M5.625,3.25 L0.375,3.25" id="Line-3-Copy"></path>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: 'IconHighlights'
    }
</script>